<template>
  <breadcrumbs-component :breadCrumbs="dashboardBreadCrumbs"/>
  <div class="dashboard-container">
    <div class="wrapper">
      <div class="box">
        <div class="tabs-container">
          <input v-if="getMoodomatEnabled || getKSSEnabled"
                 type="radio" checked="checked" name="box" id="oim_box"
                 @click="changeTab('oim')">
          <label v-if="getMoodomatEnabled || getKSSEnabled" for="oim_box" class="navlabel"
                 :class="{ 'selected-tab': isOIMSelected}">Mindset</label>
          <input v-if="getKSSEnabled" type="radio" name="box"
                 id="kss_box" @click="changeTab('kss')">
          <label v-if="getKSSEnabled" for="kss_box" class="navlabel"
                 :class="{ 'selected-tab': isKSSSelected}">
            {{ $t('DashboardComponent.collaborationTrend') }}
          </label>
          <input v-if="getMoodomatEnabled" type="radio" name="box" id="moodomat_box"
                 @click="changeTab('moodomat')">
          <label v-if="getMoodomatEnabled" for="moodomat_box" class="navlabel"
                 :class="{ 'selected-tab': isMoodomatSelected }">Mood-O-Mat</label>
          <input v-if="getKSSTrendEnabled" type="radio" name="box" id="meetingAnalysis_box"
                 @click="changeTab('meetingAnalysis')">
          <label v-if="getKSSTrendEnabled" for="meetingAnalysis_box" class="navlabel"
                 :class="{ 'selected-tab': ismeetingAnalysisSelected }">
            {{ $t('DashboardComponent.kssTrendAnalysis') }}
          </label>
        </div>
        <div v-if="selectedTab === 'oim'" class="content">
          <div class="oim">
            <div class="headline">
              <h2 id="txt_currentOIM">{{ $t('DashboardComponent.yourCurrentOMindset') }}</h2>
              <div class="read-more">
                <router-link to="knowledge-database">
                  <i>
                    <font-awesome-icon icon="fa-circle-question"/>
                  </i>
                </router-link>
              </div>
            </div>
            <div class="diagram">
              <div class="canvas-container" v-if="oimPlotLoaded">
                <bar v-if="getOimPlot" width="500" height="500" :data="getOimPlot.data"
                     :options="getOimPlot.options" id="oi_chart"/>
                <p v-else>
                  {{ $t('DashboardComponent.notEnoughDataAvailable') }}
                </p>
                <div class="getHtml" v-for="html in getDashboardHtml"
                     :key="html._id"
                     v-html="html.content[getLocale]"/>
              </div>
              <p v-else>
                {{ getErrorMessage }}
              </p>
            </div>
            <compare-oim-component/>
          </div>
        </div>
        <div v-if="selectedTab === 'kss' && getKSSEnabled" class="content">
          <div class="kss">
            <div class="headline">
              <h2 id="txt_kssHistory">{{ $t('DashboardComponent.yourKnowlExchangeHis') }}</h2>
            </div>
            <div class="diagram">
              <div class="canvas-container" v-if="kssPlotLoaded">
                <Line v-if="getKssPlot" width="500" height="300" :options="getKssPlot.options"
                      :data="getKssPlot.data" id="kss_chart"/>
                <p v-else>
                  {{ $t('DashboardComponent.notEnoughDataAvailable') }}
                </p>
              </div>
              <p v-else>
                {{ getErrorMessage }}
              </p>
            </div>
          </div>
          <dashboard-kss-history-component/>
        </div>
        <div v-if="selectedTab === 'moodomat' && getMoodomatEnabled" class="content">
          <div class="moodomat">
            <div class="headline">
              <h2 id="txt_moodomat">{{ $t('DashboardComponent.yourMoodomat') }}</h2>
            </div>
            <div class="diagram">
              <div class="canvas-container" v-if="moodomatPlotLoaded">
                <Line v-if="getMoodomatPlot" width="500" height="300"
                      :options="getMoodomatPlot.options"
                      :data="getMoodomatPlot.data" id="moodomat_chart"/>
                <p v-else>
                  {{ $t('DashboardComponent.notEnoughDataAvailable') }}
                </p>
              </div>
              <p v-else>
                {{ getErrorMessage }}
              </p>
            </div>
          </div>
        </div>
        <div v-if="selectedTab === 'meetingAnalysis' && getKSSTrendEnabled" class="content">
          <div class="kssTrend">
            <div class="headline">
              <h2 id="txt_kssTrend">{{ $t('DashboardComponent.kssTrendAnalysis') }}</h2>
            </div>
            <SearchDropdownComponent/>
            <div class="diagram">
              <div class="canvas-container" v-if="kssTrendPlotLoaded">
                <bar v-if="getKssEvalutionPerMeetingPlotData" width="500" height="300"
                     :options="getKssEvalutionPerMeetingPlotData.options"
                     :data="getKssEvalutionPerMeetingPlotData.data" id="kssTrend_chart"/>
                <p v-else>
                  {{ $t('DashboardComponent.notEnoughDataAvailable') }}
                </p>
              </div>
              <p v-else>
                {{ getErrorMessage }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectedTab === 'oim'">
        <dashboard-profile-component v-if="selectedTab === 'oim'"
                                     class="dashboard-profile-component"/>
      </div>
    </div>
  </div>
  <ProvideFeedbackComponent></ProvideFeedbackComponent>
</template>

<script>
import BreadcrumbsComponent from '@/components/Home/Shared/BreadcrumbsComponent.vue';
import { Bar, Line } from 'vue-chartjs';
import 'chartjs-adapter-date-fns';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
  TimeScale,
  Filler,
} from 'chart.js';
import CompareOimComponent from '@/components/Home/DashboardComponent/CompareOimComponent.vue';
import DashboardProfileComponent
  from '@/components/Home/DashboardComponent/DashboardProfileComponent.vue';
import DashboardKssHistoryComponent
  from '@/components/Home/DashboardComponent/DashboardKssHistoryComponent.vue';
import SearchDropdownComponent from '../Shared/SearchDropdownComponent.vue';
import ProvideFeedbackComponent from '@/components/global/ProvideFeedbackComponent.vue';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
  TimeScale,
  Filler,
);

export default {
  name: 'DashboardComponent',
  props: {
    tab: {
      type: String,
      default: 'oim',
    },
  },
  components: {
    DashboardKssHistoryComponent,
    DashboardProfileComponent,
    CompareOimComponent,
    BreadcrumbsComponent,
    Bar,
    Line,
    SearchDropdownComponent,
    ProvideFeedbackComponent,
  },
  data() {
    return {
      oimPlotLoaded: false,
      kssPlotLoaded: false,
      moodomatPlotLoaded: false,
      kssTrendPlotLoaded: false,
      selectedTab: this.tab,
      dashboardBreadCrumbs: [
        {
          route: '/dashboard',
          isActive: true,
          label: this.$t('BreadCrumbs.dashboard'),
        },
      ],
    };
  },
  methods: {
    changeTab(tabName) {
      this.selectedTab = tabName;
    },
  },
  computed: {
    isMoodomatSelected() {
      return this.selectedTab === 'moodomat';
    },
    isKSSSelected() {
      return this.selectedTab === 'kss';
    },
    isOIMSelected() {
      return this.selectedTab === 'oim';
    },
    ismeetingAnalysisSelected() {
      return this.selectedTab === 'meetingAnalysis';
    },
    getLocale() {
      return this.$i18n.locale;
    },
    getMoodomatEnabled() {
      return import.meta.env.VITE_MOODOMAT === 'true';
    },
    getKSSEnabled() {
      return import.meta.env.VITE_KSS === 'true';
    },
    getKSSTrendEnabled() {
      return import.meta.env.VITE_KSS_TREND === 'true';
    },
    getOimPlot() {
      return this.$store.getters.getOimPlotData;
    },
    getKssPlot() {
      return this.$store.getters.getKssPlotData;
    },
    getMoodomatPlot() {
      return this.$store.getters.getMoodomatPlotData;
    },
    getDashboardHtml() {
      return this.$store.getters.getDashboardHtml;
    },
    getKssEvalutionPerMeeting() {
      return this.$store.getters.getKssEvalutionPerMeeting;
    },
    getSelectedKssEvalutionPerMeeting() {
      return this.$store.getters.getSelectedKssEvalutionPerMeeting;
    },
    getKssEvalutionPerMeetingPlotData() {
      return this.$store.getters.getKssEvalutionPerMeetingPlotData;
    },
    getErrorMessage() {
      return this.$store.getters.getIsDashboardLoading
        ? this.$t('DashboardComponent.loading')
        : this.$t('DashboardComponent.notEnoughDataAvailable');
    },
  },
  unmounted() {
    this.$store.commit('resetPlotData');
    this.$store.commit('resetMindsetHtml');
    this.$store.commit('resetKssEvalutionPerMeetingData');
  },
  async mounted() {
    try {
      this.$store.commit('setIsDashboardLoading', true);
      await Promise.all([
        await this.$store.dispatch('getDashboardHtml'),
        await this.$store.dispatch('getPersonalMindset'),
      ]);
      // If data avaiable show plot
      if (this.getOimPlot) {
        this.oimPlotLoaded = true;
      }
      if (this.getKSSEnabled) {
        await this.$store.dispatch('getPersonalKssPlot');
        // If data avaiable show plot
        if (this.getKssPlot) {
          this.kssPlotLoaded = true;
        }
      }
      if (this.getMoodomatEnabled) {
        await this.$store.dispatch('getPersonalMoodomatPlot');
        // If data avaiable show plot
        if (this.getMoodomatPlot) {
          this.moodomatPlotLoaded = true;
        }
      }

      if (this.getKSSTrendEnabled) {
        await this.$store.dispatch('getKssEvalutionPerMeetingData');
        if (this.getKssEvalutionPerMeetingPlotData) {
          this.kssTrendPlotLoaded = true;
        }
      }
      this.$store.commit('setIsDashboardLoading', false);
    } catch (error) {
      const errorMessage = error.response?.data?.message || this.$t('DashboardComponent.defaultErrorMessage');
      this.$store.commit('setIsDashboardLoading', false);
      this.$toast.add({
        severity: 'error',
        summary: errorMessage,
        detail: '',
        life: 3000,
      });
    }
  },
};
</script>

<style scoped>
/*------------------ TABSYSTEM OIM > KSS ------------------*/
.dashboard-container {
  margin: 0 auto;
  position: relative;
}

.wrapper {
  min-height: 100vh;
  box-sizing: border-box;
  padding-top: 10px;
  width: 100vw;
  max-width: 960px;
  margin: 0 auto;
}

.box {
  position: relative;
}

.tabs-container {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
}

.box .navlabel {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  margin: 4px 8px;
  font-weight: 400;
  font-size: 18px;
  cursor: pointer;
  background-color: var(--color-milk);
  border-radius: 10px;
  flex: 1;
  min-width: 150px;
}

.box .content {
  padding: 0 0 20px;
  order: 99;
  flex-grow: 1;
  width: 100%;
}

.box input[type="radio"] {
  display: none;
}

.navlabel.selected-tab {
  color: var(--color-orange);
  border: 1px solid var(--color-orange);
}

.box .content .oim {
  display: block;
  box-sizing: border-box;
  background: var(--color-light);
  padding: var(--card-padding);
  border-radius: 10px;
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
}

.box .content .kss {
  display: block;
  box-sizing: border-box;
  background: var(--color-light);
  padding: var(--card-padding);
  border-radius: 10px;
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
}

.box .content .moodomat {
  display: block;
  box-sizing: border-box;
  background: var(--color-light);
  padding: var(--card-padding);
  border-radius: 10px;
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
}

.box .content .kssTrend {
  display: block;
  box-sizing: border-box;
  background: var(--color-light);
  padding: var(--card-padding);
  border-radius: 10px;
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
}

/*------------------ HEADLINE -------------------*/
.headline {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
  gap: 1.2rem;
}

.headline .read-more {
  font-size: 21px;
}

.headline .read-more a {
  color: var(--color-disabled);
}

.headline .read-more a:hover {
  color: var(--color-orange);
}

/*------------------ KSS COMPARE -------------------*/
.box .content .kss h2 {
  font-size: 23px;
  padding: 50px 0 10px;
}

.compare-container .space-container {
  display: flex;
  box-sizing: border-box;
  border-radius: 0 0 20px 20px;
  width: 100%;
  height: 100px;
  cursor: pointer;
  padding-bottom: 8px;
  flex-grow: 2;
}

.compare-container .kss-compare {
  display: flex;
  box-sizing: border-box;
  border-radius: 0 0 20px 20px;
  width: 100%;
  height: 100px;
  cursor: pointer;
  padding-bottom: 8px;
  flex-grow: 1;
}

.compare-container .kss-compare .team-compare {
  padding-top: 8px;
}

.toggle {
  margin: 3px 0 0 25px;
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
}

.toggle .toggleswitch {
  display: none;
}

.roundbutton {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  background-color: var(--color-disabled);
  display: block;
  transition: all 0.3s;
  border-radius: 40px;
  cursor: pointer;
}

.roundbutton::before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  border-radius: 100%;
  display: block;
  left: 3px;
  bottom: 2px;
  background-color: white;
  transition: all 0.3s;
}

.toggleswitch:checked + .roundbutton {
  background-color: var(--color-orange);
}

.toggleswitch:checked + .roundbutton::before {
  transform: translate(18px, 0);
}

/*------------------ DIAGRAMS -------------------*/
.diagram {
  display: block;
  position: relative;
  height: max-content;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  padding: 30px 30px 20px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 10px;
}

.getHtml {
  max-width: 100%;
}

.canvas-container {
  margin: 0.5rem auto;
  display: block;
  width: 100%;
  aspect-ratio: 4/3;
  max-height: 600px;
}

/*use plotData_helper.ts on the backend to style chartJS components. see documentation for more*/
.canvas-container canvas {
  width: 100%;
  height: 100%;
}

canvas {
  max-height: 600px;
}

iframe {
  background: transparent !important;
  width: 95vw;
  max-width: 800px;
  margin-left: -2em;
  margin-right: auto;
}

.ItemPreview {
  flex: 1 1 auto;
  overflow: hidden;
  outline: 0;
  background-color: transperent !important;
  position: relative;
}

.OneUp-html iframe {
  width: 100%;
  height: 100%;
  background-color: transperent !important;
  border: 0;
  box-shadow: 4px 4px 5px 3px rgba(0, 0, 0, .15) !important;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

/*==================== MEDIA QUERIES =====================*/
@media (max-width: 521px) {
  .box .content .kss #txt_kssHistory, #txt_moodomat, #txt_kssTrend {
    font-size: 23px;
  }

  .box .navlabel {
    margin: 16px 6px;
    padding: 16px 16px;
  }

  .canvas-container {
    aspect-ratio: 4/3;
  }

  .diagram {
    padding: 0;
    width: 93%;
  }

  .oim .headline h1 {
    font-size: 23px;
  }

  canvas {
    min-height: 400px;
  }
}

@media (min-width: 521px) and (max-width: 768px) {
  .box .navlabel {
    padding: 16px 35px;
    margin: 16px 6px;
  }

  .canvas-container {
    aspect-ratio: 4/3;
  }

  .diagram {
    padding: 0;
    width: 93%;
  }

}

@media (min-width: 769px) and (max-width: 1024px) {
  .box .navlabel {
    padding: 16px 35px;
    margin: 16px 6px;
  }

  .canvas-container {
    aspect-ratio: 4/3;
  }

  iframe {
    width: 80vw;
  }

  .diagram {
    padding: 0;
    width: 93%;
  }

}

@media (min-width: 1249px) {
  .canvas-container {
    aspect-ratio: 4/3;
  }

  .diagram {
    padding: 0;
    width: 93%;
  }

  iframe {
    width: 90%;
  }
}

</style>
